var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNamelyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0073dd;fill-rule:evenodd}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-icon-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "m196.63 11.49-34.6 73a43.82 43.82 0 0 0-3.16-3.93 59.35 59.35 0 0 0-18.64-12.71 55.43 55.43 0 0 0-22.35-4.6 57.3 57.3 0 0 0-31.62 9.19 56.3 56.3 0 0 0-21.33 24.81L.5 240.51l103.31 48 34.55-72.75c1.34 1.69 1.31 2.43 2.88 4a58.75 58.75 0 0 0 18.88 12.68 57 57 0 0 0 22.69 4.56 53.41 53.41 0 0 0 31.05-9.46 62.8 62.8 0 0 0 21.34-25.08L299.5 59.3 196.63 11.49",
    className: "cls-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamelyLogo);
export default __webpack_public_path__ + "static/media/namelyLogo.b5bc91104341c32e50d6f372da6f2e8d.svg";
export { ForwardRef as ReactComponent };